export const addExternalScript = (src: string, id: string) => {
  const oldScripts = document.querySelectorAll(`[data-id='${id}-script']`)
  oldScripts.forEach((script) => script.remove())
  const script = document.createElement('script')
  script.src = src
  script.type = 'text/javascript'
  script.setAttribute('data-id', `${id}-script`)
  document.body.appendChild(script)
}
